import { StableChildren } from '@prophecy/utils/react/StableChildren';
import { createContext, useContext, useMemo } from 'react';

import { EditMode, IDE_MODE_TYPE } from '../types';

type IDEModeContextValue = {
  mode: IDE_MODE_TYPE;
  disabledMessage?: string;
};

const IDEModeContext = createContext<IDEModeContextValue>({ mode: EditMode.disabled });

export function IDEModeProvider({
  value,
  disabledMessage,
  children
}: {
  value: IDE_MODE_TYPE;
  disabledMessage?: string;
  children: React.ReactNode;
}) {
  const memoizedValue = useMemo(() => {
    return { mode: value, disabledMessage };
  }, [value, disabledMessage]);

  return (
    <IDEModeContext.Provider value={memoizedValue}>
      <StableChildren>{children}</StableChildren>
    </IDEModeContext.Provider>
  );
}

export function useIDEMode() {
  return useContext(IDEModeContext).mode;
}

export function useIDEModeContext() {
  return useContext(IDEModeContext);
}
